import React from 'react';
import {
  Container,
  IconLum,
  Text,
  SuggestionContainer
} from '../Styles/EmptyStateStyle';
import IconLamp from '../../../../assets/icons/reinforcement/IconLamp.svg';

interface EmptyStateProps {
  text: string;
  notFoundReinforcements?: boolean;
}

const EmptyState = (props: EmptyStateProps) => {
  const { text, notFoundReinforcements } = props;
  return (
    <Container style={{ marginTop: '40px' }}>
      <IconLum src={IconLamp} alt="IconLamp" />
      <Text>{text}</Text>
      {notFoundReinforcements && (
        <SuggestionContainer>
          Te sugerimos lo siguiente:
          <ul>
            <li>
              <span>Retira algún filtro.</span>
            </li>
            <li>
              <span>Utiliza otra combinación de filtros.</span>
            </li>
          </ul>
        </SuggestionContainer>
      )}
    </Container>
  );
};

export default EmptyState;
